import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  insertFiles,
  filesDeletedAction,
  filesUpdatedAction,
} from 'src/store/files/actions';

const FileHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return insertFiles(items);

    case EVENTS.REMOVE:
      return filesDeletedAction(items.map(item => item.id));

    case EVENTS.MODIFY:
      return filesUpdatedAction(
        items.map(item => item.id),
        items,
      );

    default:
      break;
  }
  return null;
};

export default FileHandler;
